import { ModelSagresDatatable } from "@/types/model-sagres-datatable";
import { ParticipanteLicitacao } from "./participante-licitacao";

export class LoteLicitacao extends ModelSagresDatatable {
  IdLoteLicitacao: number;
  IdLicitacao: number;
  IdParticipanteLicitacao: number;

  NuSequencialLote: number;
  DeLote: string;
  QtItens: number;
  VlTotalEstimado: number;

  //este a api envia pra sinalizar se falta preencher algo no lote
  IsLotePreenchido: boolean;

  IdParticipanteLicitacaoNavigation: ParticipanteLicitacao;

  //transients / not mapped
  novaDeLote: string;
  novoNuSequencialLote: number;
  participanteVencedor: any;
}
